import { Link } from 'react-router-dom';
import { EmptyState } from '../components/ui';

export default function AIPage() {
  return (
    <EmptyState
      glyph="✦"
      title="AI features — coming soon!"
      body="We're working on AI-powered study tools for this hub: ask questions, get step-by-step explanations and more. Stay tuned."
      action={
        <Link className="btn btn-dark" to="/">
          Back to chapters
        </Link>
      }
    />
  );
}
